<template>
  <div
    class="modal__login"
    @click="verifyClose"
  >
    <div class="modal__login-container">
      <div
        v-if="loading"
        class="loading"
      >
        <div class="loader" />
      </div>

      <img
        src="@/assets/icons/close.svg"
        alt="Botão de fechar"
        class="button-close"
        @click="close"
      >

      <div class="columns">
        <div class="columns__login">
          <span
            v-if="showError"
            class="snackbar"
          >
            Login ou senha incorretos
          </span>

          <ValidationObserver v-slot="{ invalid }">
            <form @submit.prevent="submitLogin()">
              <h1 class="columns__login-title">
                Login
              </h1>

              <ValidationProvider
                v-slot="{ errors }"
                rules="required|email"
              >
                <input
                  v-model="credentials.email"
                  type="email"
                  class="columns__login-input"
                  placeholder="cristiano@gmail.com"
                  required
                >
                <span>{{ errors[0] }}</span>
              </ValidationProvider>

              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
              >
                <input
                  v-model="credentials.password"
                  type="password"
                  class="columns__login-input"
                  placeholder="Senha"
                  required
                  @keyup.enter="submitLogin()"
                >
                <span>{{ errors[0] }}</span>
              </ValidationProvider>

              <span class="columns__login-checkbox">
                <input
                  id="checkboxLembrar"
                  type="checkbox"
                  value="Lembrar de mim"
                >
                <label for="checkboxLembrar"> Mantenha-me conectado</label>
              </span>

              <input
                type="submit"
                class="columns__login-button"
                value="Entrar"
                :disabled="invalid"
              >
            </form>
          </ValidationObserver>
        </div>

        <div class="columns__social">
          <p class="columns__social-description">
            Se você ainda não tem uma conta, clique no botão abaixo para criar sua conta.
          </p>

          <button class="new-account">
            Criar conta
          </button>
          <!-- <p>Or</p>
          <button class="facebook">
            Entrar com o facebook
          </button>
          <button class="twitter">
            Entrar com o twitter
          </button> -->
        </div>
      </div>

      <section class="footer">
        <p class="footer__description">
          Então você não pode entrar na sua conta? <a href="#">Você esqueceu sua senha?</a>
        </p>
      </section>
    </div>
  </div>
</template>


<script>

import { ValidationObserver, ValidationProvider } from 'vee-validate'
import ValidateField from "@/service/mixins/validation.js"
import { mapActions } from 'vuex';

export default {
    name: "ModalLogin",

    components: {
      ValidationObserver,
      ValidationProvider
    },

    emits: ['close'],

    mixins: [ValidateField],

    data() {
      return {
        loading: false,
        credentials : {
          email: '',
          password: '',
        },
        showError: false,
      };
    },
    methods: {
      ...mapActions('auth', ['login']),

      close() {
        this.$emit('close')
      },
      verifyClose(event) {
        if(event.target === event.currentTarget)
          this.$emit("close")
      },

      async submitLogin() {
        try {
          this.loading = true
          await this.login(this.credentials).then(() => this.loading = false);
          this.$router.push('/teacher');
          this.showError = false;
        } catch (error) {
          this.showError = true;
          this.loading = false;
        }
      },
    }
}
</script>

<style lang="scss" scoped>
.modal__login {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;

  &::before {
    content: '';
    height: 100vh;
    width: 100%;
    background: rgba(0, 0, 0, .5);
    position: fixed;
  }

  .modal__login-container {
    background: white;
    position: relative;

    .loading {
      position: fixed;
      width: 100%;
      height: 100vh;
      background: rgba(0, 0, 0, 0.5);
      top: 0;
      left: 0;
      z-index: 2000;
      display: flex;
      justify-content: center;
      align-items: center;

      .loader {
        border: 16px solid #f3f3f3;
        width: 120px;
        height: 120px;
        border-radius: 50%;
        border-top: 16px solid #3498db;
        animation: spin 2s linear infinite;

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      }
    }

    .button-close {
      cursor: pointer;
      position: absolute;
      top: 10px;
      right: 10px;
    }

    .snackbar {
      position: absolute;
      background: red;
      top: 0;
      left: 0;
      width: 100%;
      padding: 10px;
      text-align: center;
      color: white;
      font-weight: 700;
      text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.32);
      box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.32);
    }

    .columns {
      display: flex;
      width: 100%;
      max-width: 800px;

      div {
        display: flex;
        width: 100%;
        flex-direction: column;
        padding: 38px 60px;
        border-right: 1px solid #D9D9D9;
      }

      &__login {
        &-title {
          color: #3A3B3F;
          margin-bottom: 20px;
          font-size: 24px;
          line-height: 28px;
        }

        &-input {
          border: 1px solid rgba(0, 0, 0, 0.32);
          border-radius: 4px;
          font-size: 14px;
          padding: 12px;
          margin-bottom: 15px;
          width: 100%;
          max-width: 280px;

          &::placeholder {
            color: #66788A;
          }
        }

        &-checkbox {
          display: flex;
          align-items: center;
          margin-bottom: 18px;

          #checkboxLembrar {
            margin-right: 8px;
          }
        }

        &-button {
          background: #2CB55B;
          border: none;
          color: #fff;
          font-size: 14px;
          border-radius: 4px;
          font-weight: 700;
          padding: 13px;
          cursor: pointer;
          width: 100%;
          max-width: 280px;
        }
      }

      &__social {
        border-right: none;
        align-items: center;
        justify-content: center;
        gap: 20px;

        &-description {
          width: 100%;
          max-width: 280px;
          font-size: 14px;
          line-height: 18px;
          text-align: center;
        }

        button {
          width: 100%;
          border: none;
          border-radius: 4px;
          color: #fff;
          padding: 12px;
          cursor: pointer;
          width: 100%;
          max-width: 280px;

          &.new-account {
            background: #1D43FF;
            font-size: 14px;
            font-weight: 500;
          }

          &.facebook {
            background: #3B5998;
            font-size: 12px;
          }

          &.twitter {
            background: #55ACEE;
          }
        }
      }
    }

    .footer {
      background: #F2F5F8;
      text-align: center;
      font-size: 14px;
      padding: 27px;
      border-radius: 0px 0px 4px 4px;

      a {
        display: inline-block;
        color: blue;
      }
    }
  }
}
</style>